import { getDefaultHeight, SVG } from "./utils";

type Props = {
  color?: string;
} & React.SVGProps<SVGSVGElement>;

export const PencilIcon: React.FC<Props> = ({ color, ...svgProps }) => {
  return (
    <SVG
      viewBox="0 0 10.32 10.32"
      xmlns="http://www.w3.org/2000/svg"
      height={getDefaultHeight(svgProps, 10.32)}
      {...svgProps}
      fill={svgProps.fill ?? "none"}
      stroke={color ?? svgProps.stroke ?? "currentColor"}
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="m3.27 9.33-2.77.5.48-2.78 6.2-6.2a.92.92 0 0 1 1.3 0l.98.98a.92.92 0 0 1 0 1.31z" />
    </SVG>
  );
};
